export const environment = {
  production: true,
  url: "https://megamarketserver.herokuapp.com"
};
